module.exports = __webpack_public_path__ + "static/media/rocks.343fab6f.jpg";